import type { IModuleDefinition, ILocalizedText } from '@platform/core/types';
import type { IPlatformCatalog } from '@platform/dao';
import { globalTypeNav } from '@platform/navigation';
import { moduleRank } from '../moduleRank';
import { typeRows } from '../typeRows';
import type { IGlobalTypeRow } from './IGlobalTypeRow';

/**
 * Рядки «Каталогу модулів» і «Форм» рівня «Глобально» (прототип v4: Object.keys(TEMPLATES) — 169 реалізованих типів записів) за
 * глобальними визначеннями (опубліковане → глобальне): типи з `globalOrder` у його порядку (старіший сервер без нього — усі реалізовані
 * типи в порядку меню); категорія — підпис категорії шаблону (`module.categoryName`); головний тип — глобальна назва модуля
 * (PATCH /platform/modules), дочірній — назва типу; «Скинути» — є глобальні назва, вимкнення чи перевизначення типу. Чиста функція.
 */
export function globalTypeRows(definitions: readonly IModuleDefinition[], platform: IPlatformCatalog | undefined,
  label: (text: ILocalizedText | null | undefined) => string, published: (module: string, rt: string) => ILocalizedText | undefined): IGlobalTypeRow[] {
  const rows = typeRows(definitions);
  const ordered = rows.some((r) => typeof r.rt.globalOrder === 'number');
  const rank = moduleRank();
  const kept = ordered ? rows.filter((r) => typeof r.rt.globalOrder === 'number') : rows;
  const at = (r: (typeof rows)[number]) => (ordered ? r.rt.globalOrder ?? 0 : rank(r.def.module.key) * 1000 + r.def.recordTypes.indexOf(r.rt));
  return [...kept].sort((a, b) => at(a) - at(b)).map((row) => {
    const module = row.def.module;
    const state = platform?.modules.find((m) => m.key === module.key);
    const type = platform?.recordTypes.find((r) => r.key === row.rt.key);
    const moduleName = state?.nameOverride || label(module.name);
    const main = row.rt === (row.def.recordTypes.find((r) => r.main) ?? row.def.recordTypes[0]);
    const enabled = state?.enabled ?? true;
    return {
      row, order: at(row),
      category: label(module.categoryName) || module.category,
      tile: globalTypeNav(module.key, row.rt.key, module.category),
      name: main ? moduleName : label(row.rt.name),
      published: main ? label(module.name) : label(published(module.key, row.rt.key) ?? row.rt.name),
      enabled,
      required: module.core || module.platformCapability,
      hostName: main ? undefined : moduleName,
      canReset: main ? !!state?.nameOverride || !enabled || !!type?.overridden : !!type?.overridden,
      globalForm: !!type?.globalForm,
    };
  });
}
